import { useEffect } from 'react'
import { useGlobalStore } from '../services/store/store'
import useNavigationGuard from './useNavigationGuard'

const useFilterResetOnNavigation = () => {
	useNavigationGuard()

	const previousRoute = useGlobalStore((state) => state.previousRoute)
	const currentRoute = useGlobalStore((state) => state.currentRoute)
	const resetFiltersSorts = useGlobalStore((state) => state.resetFiltersSorts)

	useEffect(() => {
		if (
			previousRoute &&
			previousRoute.includes('/toolkits') &&
			(!currentRoute || !currentRoute.startsWith('/toolkit/'))
		) {
			resetFiltersSorts()
		}
	}, [previousRoute, currentRoute, resetFiltersSorts])
}

export default useFilterResetOnNavigation
